module.exports = __webpack_public_path__ + "img/exam_jan_2025_4p4bv7qz.3bbaed57.jpg";